import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  error: {
    color: '#f00',
    whiteSpace: 'pre-wrap'
  }
};

const enhance = compose();

const text = enhance(({ classes, message }) => {
  return <div className={classes.error}>{message}</div>;
});

export default withRouter(withStyles(styles)(text));
